var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div',{staticClass:"chart__grid"},[_c('div',{staticClass:"chart__grid__items"},_vm._l((_vm.works),function(work,index){return _c('TimeControlCardChartItem',{key:index,attrs:{"work":work,"mathMaxWorkSize":_vm.mathMaxWorkSize}})}),1),_c('hr')])])
}
var staticRenderFns = []

export { render, staticRenderFns }